"use client"
/* */
import { jsx } from 'react/jsx-runtime';
import 'react';
import { IconPhoto } from '@tabler/icons-react';
import { Icon } from '../../../Icon/Icon.mjs';
import '../../../../lib/viewComponentContext/viewComponentContext.mjs';
import { IconFile } from '../../../Icon/components/icons/IconFile.mjs';
import { Avatar as Avatar$1 } from '../../../Avatar/Avatar.mjs';
import { Image } from '../../../Image/Image.mjs';

const Avatar = (props) => {
  const { type, imageSrc } = props;
  if (imageSrc) {
    return /* @__PURE__ */ jsx(Avatar$1, { children: /* @__PURE__ */ jsx(Image, { src: imageSrc }) });
  }
  return /* @__PURE__ */ jsx(Avatar$1, { color: "blue", children: type?.startsWith("image") ? /* @__PURE__ */ jsx(Icon, { children: /* @__PURE__ */ jsx(IconPhoto, {}) }) : /* @__PURE__ */ jsx(IconFile, {}) });
};

export { Avatar, Avatar as default };
//# sourceMappingURL=Avatar.mjs.map
